import { find } from 'lodash'


// words that don't follow any rules
const SPECIAL_INFLECTIONS = [
  { s: 'datum', p: 'data' },
]

// look up special inflection for word in either form
const lookupInWordList = noun =>
  find(SPECIAL_INFLECTIONS, { s: noun }) || find(SPECIAL_INFLECTIONS, { p: noun })

// look it up and ask for the singular form
const specialSingular = noun => lookupInWordList(noun)?.s

// look it up and ask for the plural form
const specialPlural = noun => lookupInWordList(noun)?.p

// special ending rules return either replaced string or false so they can be chained
// replace ending ies with y if matching
const iesToY = noun => noun.endsWith('ies') && noun.replace(/ies$/, 'y')

// replace ending y with ies if matching
const yToIes = noun => noun.endsWith('y') && noun.replace(/y$/, 'ies')

// drop trailing s if it's there
const removeS = noun => noun.endsWith('s') && noun.slice(0, noun.length-1)

// add trailing is if it's missing
const appendS = noun => !noun.endsWith('s') && `${noun}s`


export const
  // return the singular form of the given noun using a small handful of heuristics
  singularize = noun =>      // use the first conversion that works:
    specialSingular(noun) || // check special word list
      iesToY(noun) ||        // check ies ending
      removeS(noun) ||       // check s ending
      noun,                  // use as is

  // returns the plural form of the given noun using a small handful of heuristics
  // NOTE: do not confuse with utils/strings pluralize which is about quantity agreement grammar
  pluralize = noun =>        // use the first conversion that works:
    specialPlural(noun) ||   // check the special word list
      yToIes(noun) ||        // check y ending
      appendS(noun) ||       // check no s ending
      noun                   // use as is

export default { singularize, pluralize }
